import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { format } from "date-fns";

interface AvailabilityParams {
  checkIn: Date | undefined;
  checkOut: Date | undefined;
  totalGuests: number;
}

export const useAvailability = ({ checkIn, checkOut, totalGuests }: AvailabilityParams) => {
  return useQuery({
    queryKey: ["availability", checkIn?.toISOString(), checkOut?.toISOString(), totalGuests],
    queryFn: async () => {
      if (!checkIn || !checkOut) return null;

      const { data, error } = await supabase.rpc("check_availability", {
        _check_in: format(checkIn, "yyyy-MM-dd"),
        _check_out: format(checkOut, "yyyy-MM-dd"),
        _guests: totalGuests,
      });

      if (error) throw error;
      return data as string[];
    },
    enabled: !!checkIn && !!checkOut,
    staleTime: 30 * 1000,
    // Mobile connections drop requests ("Load failed"); retry quickly instead of
    // the default slow exponential backoff that leaves the spinner up ~15s.
    retry: 2,
    retryDelay: 500,
  });
};
